import { render, staticRenderFns } from "./CommentEdit.vue?vue&type=template&id=5b528b59&scoped=true&"
import script from "./CommentEdit.vue?vue&type=script&lang=js&"
export * from "./CommentEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommentEdit.vue?vue&type=style&index=0&id=5b528b59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b528b59",
  null
  
)

export default component.exports